class ExtendSectionT3MuseDev extends ExtendSectionBase {
  constructor() {
    super();
  }

  init() {
    this._listenSectionLoad();

    const _safeInit = (fn) => {
      try {
        return fn();
      } catch (e) {
        console.warn(`[ExtendSectionT3MuseDev] ${fn.name} 初始化失败:`, e);
        return null;
      }
    };

    // 同一个效果只初始化一次
    const wirelessAudioEffect = _safeInit(() => this.initWirelessAudio());

    // 滚动驱动
    this._scrollEffects = [wirelessAudioEffect].filter(Boolean);

    // 尺寸变化驱动
    this._resizeEffects = [wirelessAudioEffect].filter(Boolean);

    // 初始化时先计算一次当前状态
    this._scrollEffects.forEach((fn) => fn());
  }

  onScroll() {
    if (this._scrollEffects) {
      this._scrollEffects.forEach((fn) => fn());
    }
  }

  onResize() {
    super.onResize();

    if (this._resizeEffects) {
      this._resizeEffects.forEach((fn) => fn());
    }
  }

  initWirelessAudio() {
    const selector = ".extend-t3muse-wireless-audio [data-et3muse-wa-scroll]";

    const records = new WeakMap();

    let frameId = null;

    const update = () => {
      frameId = null;

      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      // 图片区顶部到达视口高度的 35% 时切换
      const triggerLine = viewportHeight * 0.25;

      const elements = document.querySelectorAll(selector);

      elements.forEach((element) => {
        const scene = element.querySelector("[data-wa-system-scene]");

        if (!scene) {
          return;
        }

        const primary = element.querySelector(".et3muse-wa__art");

        let record = records.get(element);

        if (!record || record.scene !== scene || record.primary !== primary) {
          record = {
            scene: scene,
            primary: primary,
            primaryAriaHidden: primary ? primary.getAttribute("aria-hidden") : null,
            visible: null
          };

          records.set(element, record);
        }

        const rect = element.getBoundingClientRect();

        // 仅根据位置判断，不检查图片数量或加载状态
        const showSystem = rect.width > 0 && rect.height > 0 && rect.top <= triggerLine;

        if (record.visible === showSystem) {
          return;
        }

        record.visible = showSystem;

        element.classList.toggle("is-system-visible", showSystem);

        scene.setAttribute("aria-hidden", showSystem ? "false" : "true");

        if (primary) {
          if (showSystem) {
            primary.setAttribute("aria-hidden", "true");
          } else if (record.primaryAriaHidden === null) {
            primary.removeAttribute("aria-hidden");
          } else {
            primary.setAttribute("aria-hidden", record.primaryAriaHidden);
          }
        }
      });
    };

    const scheduleUpdate = () => {
      if (frameId !== null) {
        return;
      }

      frameId = window.requestAnimationFrame(update);
    };

    return scheduleUpdate;
  }
}
